import * as React from 'react';

import { PageHeaderContainer } from '../PageHeader';
import { AddBlogPostFormContainer } from '../AddPostForm';
import { PageWithSidebar as Layout } from '../../components/Layouts';
import { SidebarIndicateTheSourceTip, SidebarWhatToTellAboutTip } from '../../components/SidebarTips';

/**
 * Контейнер страницы добавления/редактирования поста блога
 */
export const AddBlogPageContainer = () => {
  return (
    <Layout header={<PageHeaderContainer />} body={<AddBlogPostFormContainer />}>
      <SidebarWhatToTellAboutTip />
      <SidebarIndicateTheSourceTip />
    </Layout>
  );
};
